<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
    <div id="sensor">
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <vx-card title="Paper Rolls - Sale Quantity by Location for 2020">
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts type="heatmap" height="350" :options="heatMapChart.chartOptions" :series="generateDataHeatMap()"></vue-apex-charts>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <vx-card title="$ Sale by Location for 2020">
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts type="heatmap" height="350" :options="heatMapChart.chartOptions" :series="generateDataHeatMap1()"></vue-apex-charts>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vx-card title="Sale intensity sensing by Location for 2020">
            <div slot="no-body" class="p-6 pb-0"></div>
          </vx-card>
          <!-- <vs-alert color="danger" icon="new_releases" active="true" class="mt-5">
            <p>Sale intensity Map</p>
          </vs-alert> -->
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <div id="map" class="mapbox">
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import appConfig from "@/../appConfig.js";

import VueApexCharts from "vue-apexcharts";
// import webtreemap from "webtreemap-cdt"
import {createWebTree} from "./../shared/services/sandbox/webtree"
import Stats from "./../shared/services/sandbox/stats"
// const Stats = require('./../shared/services/sandbox/stats');
const { transformData, appendColor, extractData } = require('./../shared/services/sandbox/utils');
const heatMapData = [{"city":"Mumbai","Jan20":2531,"Feb20":2406,"Mar20":2514,"Apr20":1250,"May20":1177,"Jun20":1255,"Jul20":1318,"Aug20":1613,"Sep20":1803,"Oct20":2043,"Nov20":2044,"Dec20":2171,"Jan21":2069,"Feb21":1925},{"city":"Delhi-NCR","Jan20":1701,"Feb20":1653,"Mar20":1882,"Apr20":1151,"May20":1254,"Jun20":1310,"Jul20":1353,"Aug20":1456,"Sep20":1566,"Oct20":1819,"Nov20":1775,"Dec20":1799,"Jan21":1872,"Feb21":1734},{"city":"Bangalore","Jan20":1416,"Feb20":1332,"Mar20":1472,"Apr20":1090,"May20":1179,"Jun20":1208,"Jul20":1091,"Aug20":1141,"Sep20":1111,"Oct20":1206,"Nov20":1279,"Dec20":1328,"Jan21":1307,"Feb21":1115},{"city":"Hyderabad","Jan20":964,"Feb20":1011,"Mar20":1170,"Apr20":779,"May20":906,"Jun20":946,"Jul20":832,"Aug20":867,"Sep20":927,"Oct20":1059,"Nov20":1095,"Dec20":1213,"Jan21":1176,"Feb21":1130},{"city":"Punjab","Jan20":846,"Feb20":857,"Mar20":854,"Apr20":398,"May20":626,"Jun20":780,"Jul20":821,"Aug20":859,"Sep20":963,"Oct20":1081,"Nov20":1089,"Dec20":1086,"Jan21":1075,"Feb21":931},{"city":"Ahmedabad","Jan20":1020,"Feb20":1014,"Mar20":944,"Apr20":453,"May20":418,"Jun20":664,"Jul20":872,"Aug20":933,"Sep20":997,"Oct20":986,"Nov20":880,"Dec20":956,"Jan21":932,"Feb21":848},{"city":"Pune","Jan20":882,"Feb20":787,"Mar20":900,"Apr20":449,"May20":548,"Jun20":630,"Jul20":605,"Aug20":639,"Sep20":684,"Oct20":738,"Nov20":747,"Dec20":829,"Jan21":831,"Feb21":810},{"city":"Chennai","Jan20":478,"Feb20":471,"Mar20":518,"Apr20":345,"May20":405,"Jun20":414,"Jul20":425,"Aug20":463,"Sep20":514,"Oct20":575,"Nov20":554,"Dec20":663,"Jan21":607,"Feb21":532}]
const heatMapData1 = [{"city":"Bangalore","Jan20":18226906,"Feb20":23539715,"Mar20":12711873,"Apr20":5685573,"May20":4759803,"Jun20":7113324,"Jul20":6003138,"Aug20":7008236,"Sep20":3325977,"Oct20":11158445,"Nov20":27611839,"Dec20":11026882},{"city":"Mumbai","Jan20":13288950,"Feb20":14535945,"Mar20":14784705,"Apr20":9274810,"May20":6080500,"Jun20":6836675,"Jul20":9639250,"Aug20":6690625,"Sep20":10295725,"Oct20":9594975,"Nov20":11777594,"Dec20":12145307},{"city":"Delhi-NCR","Jan20":8822298,"Feb20":11043394,"Mar20":12071340,"Apr20":6120038,"May20":6184382,"Jun20":7569490,"Jul20":10481989,"Aug20":7678778,"Sep20":9604465,"Oct20":8177282,"Nov20":8291420,"Dec20":8778840},{"city":"Punjab","Jan20":10890117,"Feb20":13244260,"Mar20":9925944,"Apr20":3213600,"May20":5953350,"Jun20":5506600,"Jul20":6182249,"Aug20":5858900,"Sep20":6735348,"Oct20":7791110,"Nov20":8719521,"Dec20":8024500},{"city":"Ahmedabad","Jan20":4354130,"Feb20":6444340,"Mar20":4220350,"Apr20":1786400,"May20":1608400,"Jun20":3131000,"Jul20":5150562,"Aug20":3843700,"Sep20":4330236,"Oct20":4410153,"Nov20":3815199,"Dec20":4556783},{"city":"Pune","Jan20":8890405,"Feb20":5616059,"Mar20":2758454,"Apr20":2407200,"May20":5210700,"Jun20":3652855,"Jul20":3421800,"Aug20":2544400,"Sep20":3087450,"Oct20":2699990,"Nov20":2405643,"Dec20":2327883},{"city":"Hyderabad","Jan20":2969150,"Feb20":2673400,"Mar20":4083023,"Apr20":3691801,"May20":3378325,"Jun20":4509743,"Jul20":3208102,"Aug20":3623919,"Sep20":3683911,"Oct20":3574596,"Nov20":4712114,"Dec20":4409769},{"city":"Chennai","Jan20":570950,"Feb20":590250,"Mar20":768003,"Apr20":692100,"May20":530700,"Jun20":523420,"Jul20":510700,"Aug20":703900,"Sep20":1122222,"Oct20":944775,"Nov20":738150,"Dec20":1004400}]
export default {
  props: {
    artefact: { type: Object, required: true },
  },
  data() {
    return {
      colors: appConfig.colors,
      isDataFetched: false,
      heatMapChart: {
        series: [],
        chartOptions: {
          colors: appConfig.chart.colors,
          dataLabels: {
            enabled: false
          },
          colors: ["#008FFB"],
        }
      }
    };
  },
  methods: {
    async getCovid19Data() {
        const data = await fetch("https://api.covid19india.org/state_district_wise.json");
        const stateData = await fetch("https://api.rootnet.in/covid19-in/unofficial/covid19india.org/statewise");
        return await Promise.all([data.text(), stateData.text()]);
    },

    init() {
      this.getCovid19Data().then((data) => {
          if (!data || !data.length) throw new Error("data is empty kindly check the endpoint");
          this.isDataFetched = true;
          const label = this.artefact.guide && this.artefact.guide.note ? this.artefact.guide.note : 'Sale Intensity sensing';
          const districtWiseData = JSON.parse(data[0]);
          const stateWiseData = JSON.parse(data[1] || []);
          const rootStats = new Stats('/');
          const statsJSON = transformData(districtWiseData, []);
          const stateJSON = extractData(stateWiseData, []);
          statsJSON.forEach((source) => {
              this.createNode(source, rootStats);
          });
          rootStats.createTile(rootStats, rootStats.data['$area']);
          appendColor(rootStats);
          const event = new CustomEvent('sense-event', { detail: { 'label': label, 'districtWise': rootStats, 'stateWise': stateJSON } });
          // Dispatch the event
          window.dispatchEvent(event);
      });
    },

    createNode(source, tree) {
        const parts = source.path.split('/');
        let node = tree;
        node.data['$area'] += source.cases;
        node.setClassName(source.getClassName());
        parts.forEach((part) => {
            let child = node.children.find(function (child) {
                return child.name == part;
            });
            if (!child) {
                child = new Stats(part);
                child.setClassName(source.getClassName());
                node.children.push(child);
            }
            node = child;
            if (source.cases) node.data['$area'] += source.cases;
        });
    },

    generateDataHeatMap () {
      const series = []
      for(let cityData of heatMapData) {
        let timeseries = []
        const keys = Object.keys(cityData);
        const values = Object.values(cityData)
        for(let i = 1; i < 13; i++) {
          const x = keys[i]
          const y = values[i]

          timeseries.push({
            x,
            y
          })
        }
        series.push({
          name: cityData.city,
          data: timeseries
        })
      }
      return series
    },
    generateDataHeatMap1 () {
      const series = []
      for(let cityData of heatMapData1) {
        let timeseries = []
        const keys = Object.keys(cityData);
        const values = Object.values(cityData)
        for(let i = 1; i < 13; i++) {
          const x = keys[i]
          const y = values[i]

          timeseries.push({
            x,
            y
          })
        }
        series.push({
          name: cityData.city,
          data: timeseries
        })
      }
      return series
    }         
  },
  computed: {
    
  },
  mounted() {
    this.init();
  },
  components: {
    VueApexCharts
  },
  beforeDestroy() {
    this.isDataFetched = false;
  }
};
</script>

<style lang="scss">
  .mapbox {
    position: absolute;
    cursor: pointer;
    -webkit-user-select: none;
    min-height: 500px;
    height: 100%;
    left: 35px;
    right: 35px;
  }

#map {
  /* WebTreeMap CSS. */
  .webtreemap-node {
      /* Required attributes. */
      position: absolute;
      overflow: hidden;
      /* To hide overlong captions. */
      background: white;
      /* Nodes must be opaque for zIndex layering. */
      border: solid 1px black;
      /* Calculations assume 1px border. */

      /* Optional: CSS animation. */
      transition: top 0.3s,
          left 0.3s,
          width 0.3s,
          height 0.3s;
  }

  /* Optional: highlight nodes on mouseover. */
  .webtreemap-node:hover {
      background: #eee;
  }

  /* Optional: Different background colors depending on symbol. */
  .webtreemap-symbol-bss {
      background: #66C2A5;
  }

  .webtreemap-symbol-data {
      background: #FC8D62;
  }

  .webtreemap-symbol-read-only_data {
      background: #8DA0CB;
  }

  .webtreemap-symbol-code {
      background: #E78AC3;
  }

  .webtreemap-symbol-weak_symbol {
      background: #A6D854;
  }

  .webtreemap-symbol-bss.webtreemap-aggregate {
      background: #B3E2CD;
  }

  .webtreemap-symbol-data.webtreemap-aggregate {
      background: #FDCDAC;
  }

  .webtreemap-symbol-read-only_data.webtreemap-aggregate {
      background: #CBD5E8;
  }

  .webtreemap-symbol-code.webtreemap-aggregate {
      background: #F4CAE4;
  }

  .webtreemap-symbol-weak_symbol.webtreemap-aggregate {
      background: #E6F5C9;
  }

  #legend>* {
      border: solid 1px #444;
  }

  /* Optional: Different borders depending on level. */
  .webtreemap-level0 {
      border: solid 1px #444;
  }

  .webtreemap-level1 {
      border: solid 1px #666;
  }

  .webtreemap-level2 {
      border: solid 1px #888;
  }

  .webtreemap-level3 {
      border: solid 1px #141414;
  }

  .webtreemap-level4 {
      border: solid 1px #ccc;
  }

  /* Optional: styling on node captions. */
  .webtreemap-caption {
      font-family: Gill Sans W04 Book,Helvetica,Arial,sans-serif;;
      font-size: 12px;
      padding: 2px;
      text-align: center;
      color: #000
  }
}

</style>
